export const Colors = {
  primary: '#1B70D1',
  primaryDark: '#084298',
  primaryMid: '#3B82F6',
  primaryLight: '#EFF6FF',
  accent: '#F86932',
  accentLight: '#FFF7ED',
  accentDark: '#C2410C',
  success: '#10B981',
  successLight: '#D1FAE5',
  warning: '#F59E0B',
  error: '#EF4444',
  errorLight: '#FEE2E2',
  info: '#0EA5E9',
  infoLight: '#E0F2FE',

  background: '#F9FAFB',
  surface: '#FFFFFF',
  card: '#FFFFFF',

  text: '#111827',
  textSecondary: '#4B5563',
  textLight: '#9CA3AF',
  textInverse: '#FFFFFF',

  border: '#E5E7EB',
  divider: '#F3F4F6',

  present: '#10B981',
  absent: '#EF4444',
  late: '#F59E0B',
  holiday: '#3B82F6',

  gradientStart: '#0B5ED7',
  gradientEnd: '#3B82F6',
};

export const Spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const FontSize = {
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18,
  xxl: 22,
  xxxl: 28,
};

export const BorderRadius = {
  sm: 12,
  md: 18,
  lg: 24,
  xl: 32,
  full: 9999,
};
